import { useState, useEffect } from "react";
import { makeApiRequest, apiRoutes } from "constants/apiRoutes";
import { useAuth } from "utilities/auth";
import { useEffectiveCompanyId } from "hooks/useEffectiveCompanyId";

export function useRuleConstraints() {
  const { user } = useAuth();

  const [constraints, setConstraints] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const companyId = useEffectiveCompanyId();

  useEffect(() => {
    async function fetchConstraints() {
      setLoading(true);
      try {
        const res = await makeApiRequest(
          "get",
          apiRoutes.getRuleConstraints,
          { id: user.id, accessToken: user.accessToken },
          companyId
        );

        setConstraints(res.data || []);
      } catch (err) {
        console.error("Failed to fetch rule constraints:", err);
        setError(err.message || "Failed to fetch rule constraints");
      } finally {
        setLoading(false);
      }
    }

    if (user && companyId) {
      fetchConstraints();
    }
  }, [companyId]);

  return { constraints, loading, error };
}
